import type {StylesConfig} from 'react-select';

/** CSS variables resolve in the current theme, including an already open menu. */
export const adminSelectStyles: StylesConfig<any, false> = {
    control: (base, state) => ({...base, backgroundColor:'var(--ad-surface, #fff)',
        color:'var(--ad-ink, #29364d)', borderColor:state.isFocused?'var(--ad-primary)':'var(--ad-line, #e8ebf2)',
        borderRadius:12, minHeight:44, boxShadow:state.isFocused?'0 0 0 1px var(--ad-primary)':'none',
        '&:hover':{borderColor:'var(--ad-primary)'}}),
    menu: base => ({...base, zIndex:30, backgroundColor:'var(--ad-surface, #fff)',
        color:'var(--ad-ink, #29364d)', border:'1px solid var(--ad-line)', borderRadius:12, overflow:'hidden'}),
    option: (base, state) => ({...base, color:state.isSelected?'#fff':'var(--ad-ink, #29364d)',
        backgroundColor:state.isSelected?'var(--ad-primary)':state.isFocused?'var(--ad-soft)':'var(--ad-surface, #fff)',
        '&:active':{backgroundColor:'var(--ad-primary)',color:'#fff'}}),
    singleValue: base => ({...base,color:'var(--ad-ink, #29364d)'}),
    input: base => ({...base,color:'var(--ad-ink, #29364d)',margin:0,padding:0}),
    placeholder: base => ({...base,color:'var(--ad-muted, #748095)'}),
    indicatorSeparator: base => ({...base,backgroundColor:'var(--ad-line)'}),
    dropdownIndicator: base => ({...base,color:'var(--ad-muted)'}),
    clearIndicator: base => ({...base,color:'var(--ad-muted)'}),
    noOptionsMessage: base => ({...base,color:'var(--ad-muted)'}),
    loadingMessage: base => ({...base,color:'var(--ad-muted)'}),
};
